import React from 'react';

import { SettingsInjections } from 'generics/settingsInjections';
import { _I_ } from './translate';

export default class ViewLegalFooter extends React.Component {
  render() {
    const target = "_blank";

    const legalHost = SettingsInjections.getLegalHost();

    const termsConditions = `${legalHost}/${_I_("Legal.Localization")}/`;
    const termsService = `${legalHost}/${_I_("Legal.Localization")}/termsofservice/`;
    const privacyPolicy = `${legalHost}/${_I_("Legal.Localization")}/privacypolicy/`;
    const cookiesPolicy = `${legalHost}/${_I_("Legal.Localization")}/cookie/`;

    const noticeAchievements = `${legalHost}/${_I_("Legal.Localization")}/legal-notice-achievements`;

    const currentYear = new Date().getFullYear();
    const mode = SettingsInjections.getMode();

    return (
      <div className="footer">
        {mode !== 'pixstorm' &&
          <React.Fragment>
            <div className="legalLinks">
              <a className="legalTerms" target={target} href={termsConditions}>{_I_("Legal.TermsConditions")}</a>
              <a className="legalTerms" target={target} href={termsService}>{_I_("Legal.TermsService")}</a>
              <a className="legalTerms" target={target} href={privacyPolicy}>{_I_("Legal.PrivacyPolicy")}</a>
              <a className="legalTerms js-cookie-first-settings" target={target} href={cookiesPolicy} data-test-id="cookie-policy-settings">{_I_("Legal.CookiesPolicy")}</a>
            </div>

            <div className="copyright">© {currentYear} {_I_("Legal.Copyright")}</div>
          </React.Fragment>
        }
        {mode == 'pixstorm' &&
          <div className="copyright">{_I_("Legal.Copyright")} <a className="legalTerms" target={target} href={noticeAchievements}>{_I_("Legal.Copyright.link")}</a></div>
        }
      </div>
    );
  }
}